import React from "react";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";

import "../../components/cards/.Card.css";

const CardImage = ({
  image,
  children,
  imgStyle,
  itemId,
  classNameDiv = "card-body",
  classNameCard = "card-image",
  classNameChildren = "aria-button",
  ...props
}) => {
  return (
    <div className={classNameDiv}>
      <Card className={classNameCard} key={"card_" + itemId}>
        <CardMedia
          component="img"
          image={image}
          key={"media_" + itemId}
          style={imgStyle}
          {...props}
        />
        <div className={classNameChildren}>{children}</div>
      </Card>
    </div>
  );
};

export default CardImage;
